// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Tabs } from "antd";
import "antd/dist/antd.css";
import cardStyles from "assets/jss/material-dashboard-pro-react/components/cardStyle.js";
import styles1 from "assets/jss/material-dashboard-pro-react/views/chartsStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import CommunityPartnership from "./CommunityPartnership";
import CounselingAndSupport from "./CounselingAndSupport";
import ProfessionalDevelopment from "./ProfessionalDevelopment";
import ResearchAndInnovation from "./ResearchAndInnovation";
import AssessmentAnalysis from "./AssessmentAnalysis"
import {
  fetchImprovementByResourceAndResourceIdAndType,
} from "../../../../../reduxToolkit/features/annualProgramAnalysis/annualProgramAnalysisSlice";

const useStyles3 = makeStyles(styles1);
const { TabPane } = Tabs;

const useStyles = makeStyles((theme) => ({
  root: {
    width: "fit-content",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    "& svg": {
      margin: theme.spacing(1.5),
    },
    "& hr": {
      margin: theme.spacing(0, 0.5),
    },
  },
}));
const useStyles1 = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));
const useStyles2 = makeStyles(styles);
const useCardStyles = makeStyles(cardStyles);

export default function ProgramActivities(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const classes1 = useStyles1();
  const classes2 = useStyles2();
  const classes3 = useStyles3();
  const dispatch = useDispatch();

  const [activeChildTabKey, setActiveChildTabKey] = useState(1)

  let type = "programActivities";
  let resource = "annualProgram";
  let resource_id = props.AnnualProgramReport?.id;

  let data = {
    resource,
    resource_id,
    type,
  };
  const fetchAnalysis = () => {
    dispatch(fetchImprovementByResourceAndResourceIdAndType(data))
      .then(unwrapResult)
      .catch((error) => {
        console.error(error);
      })
  }
  useEffect(() => {
    if (props.activeParentTabKey === "6") {
      fetchAnalysis()
    }
  }, []);

  return (
    <div>
      <Tabs onChange={(activeKey) => { setActiveChildTabKey(activeKey); console.log(activeKey) }} type="card" defaultActiveKey="1" destroyInactiveTabPane>
        <TabPane tab={t("Student Counseling And Support")} key="1" forceRender>
          <CounselingAndSupport
            AnnualProgramReport={props.AnnualProgramReport}
          />
        </TabPane>

        <TabPane tab={t("Professional Development")} key="2" forceRender>
          <ProfessionalDevelopment
            AnnualProgramReport={props.AnnualProgramReport}
          />
        </TabPane>
        <TabPane tab={t("Research and innovation")} key="3" forceRender>
          <ResearchAndInnovation
            AnnualProgramReport={props.AnnualProgramReport}
          />
        </TabPane>

        <TabPane tab={t("Community partnership")} key="4" forceRender>
          <CommunityPartnership
            AnnualProgramReport={props.AnnualProgramReport}
          />
        </TabPane>

        <TabPane tab={t("Analysis")} key="5" forceRender>
          <AssessmentAnalysis AnnualProgramReport={props.AnnualProgramReport} fetchAnalysis={fetchAnalysis} activeChildTabKey={activeChildTabKey} />
        </TabPane>
      </Tabs>
    </div>
  );
}
